import CoursewareDialog from "../../actions/courseware/CoursewareDialog.tsx";
import { useMemo } from "react";
import { CourseMaterial } from "./coursesLoader.ts";
import { AccessCode } from "../../../../common/api/decimal/common-types/manageAssets.ts";
import {
  CoursewareRequiredAsset,
  CoursewareRequiredLicense,
} from "../../actions/courseware/coursewareDialogUtils.ts";

export default function LibraryAccessCodeDialog({
  linkedUrl,
  onRequestClose,
  courseMaterial,
}: {
  linkedUrl: string;
  onRequestClose: () => void;
  courseMaterial: CourseMaterial;
}) {
  // Currently only known to support connexions gift cards
  const accessCode: AccessCode = useMemo(() => {
    const urlObj = new URL(linkedUrl);
    const existingCode = urlObj.searchParams.get("code");
    const url = urlObj.searchParams.get("href") ?? undefined;
    return {
      code: existingCode,
      courseKey: null,
      href: url,
      revealed: !!existingCode,
      ssoOnly: false,
    };
  }, [linkedUrl]);

  const manageAsset: CoursewareRequiredAsset = useMemo(() => {
    return {
      vbid: courseMaterial.vbid,
      title: courseMaterial.title,
    };
  }, [courseMaterial]);

  const license: CoursewareRequiredLicense = useMemo(() => {
    return {
      accessCode,
    };
  }, [accessCode]);

  return (
    <CoursewareDialog
      asset={manageAsset}
      license={license}
      onRequestClose={onRequestClose}
    />
  );
}
